module.exports = __webpack_public_path__ + "media/images/lb/719-0918496629b283c3d6343846fc9118cf.svg";